<template>
  <div>
    <a-modal title="查看公告" placement="right" :visible="visible" :width="1200" @cancel="onClose" :footer="null">
      <div>
          <a-form layout="inline" :disabled="true">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="公告标题" prop="noticeTitle">
                <a-input v-model="form.noticeTitle" style="width: 260px" disabled placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="副标题" prop="subtitle">
                <a-input v-model="form.subtitle" style="width: 260px" disabled placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>

            

            <a-col :md="24" :sm="24" style="margin-top: 20px">
              <a-form-item label="内容" prop="noticeContent">
                <div class="editor">
                  <editor v-model="form.noticeContent" :readOnly="true" />
                </div>
              </a-form-item>
            </a-col>

            
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Editor from '@/components/Editor/Editor'
import { getNotice } from '@/api/system/notice'
export default {
 components: {
    Editor
  },
  data() {
    return {
      form:{},

      visible: false,


    }
  },
  methods: {
   
    open(row) {
      console.log(row)
      this.visible = true
      this.getNoticeList(row)
     
    },

    //获取详情
    getNoticeList(row){
      console.log(row);
      getNotice(row.id).then(res=>{
        console.log(res,';;;;;;;;;;;;;;;;;;;;;;;;;;');
        if(res.code=='20001'){
          this.form = res.data
        }
        
      })
    },
    onClose() {
      this.visible = false
    }
  }
}
</script>

<style  scoped>
  .editor {
    height: 500px;
  }

</style>
